export const DISALLOWED_EMAILS_ANTIGEN = [
  "mahmutbegovicpoliklinika@gmail.com",
  "epion.laboratorija@gmail.com",
  "sabicpoliklinika@gmail.com"
]